export const initialSecurityEventsTable = {
    data: [],
    loading: false
};
